import { render, staticRenderFns } from "./PurchasingModal.vue?vue&type=template&id=de185b8e"
import script from "./PurchasingModal.vue?vue&type=script&lang=js"
export * from "./PurchasingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports